import { useModals } from '../../app/context/modals-context';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

// Шапка списку: пошук, кнопка фільтра й кнопка створення.
//
// Раніше кнопки показувались завжди (навіть там, де створювати нічого), а
// пошук робив navigate('?q=...') — це стирало решту параметрів (фільтри,
// сторінку). Тепер обидві кнопки вмикаються пропсами, а пошук лише додає
// свій параметр і скидає сторінку на першу.
const PageHeader = ({ placeholder, link, createLink, filters = null, searchable = true }) => {
  const { setIsModalOpen } = useModals();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const activeQuery = searchParams.get('q') || '';
  const [searchQuery, setSearchQuery] = useState(activeQuery);

  // Якщо параметр змінили ззовні (перехід за посиланням, скидання фільтрів),
  // поле має показувати те, за чим справді відфільтровано.
  useEffect(() => {
    setSearchQuery(activeQuery);
  }, [activeQuery]);

  const applySearch = (value) => {
    const nextParams = new URLSearchParams(searchParams);
    const normalized = value.trim();

    if (normalized) {
      nextParams.set('q', normalized);
    } else {
      nextParams.delete('q');
    }

    nextParams.delete('page');
    setSearchParams(nextParams);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    applySearch(searchQuery);
  };

  const createHref = createLink || link;
  const hasFilters = Array.isArray(filters) && filters.length > 0;

  return (
    <div className="header">
      {searchable && (
        <form className="header__input-content" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button type="submit">Пошук</button>
        </form>
      )}

      {activeQuery && (
        <button
          type="button"
          className="header__filter-button"
          onClick={() => {
            setSearchQuery('');
            applySearch('');
          }}
        >
          Скинути пошук
        </button>
      )}

      {hasFilters && (
        <button
          type="button"
          className="header__filter-button"
          onClick={() => setIsModalOpen('filter')}
        >
          Фільтр
        </button>
      )}

      {createHref && (
        <button
          type="button"
          className="header__func-btn"
          title="Додати"
          onClick={() => navigate(createHref)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path
              d="M5.57143 5.57143V0H7.42857V5.57143H13V7.42857H7.42857V13H5.57143V7.42857H0V5.57143H5.57143Z"
              fill="currentColor"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default PageHeader;
